import { render, staticRenderFns } from "./ShuJuOld.vue?vue&type=template&id=6396498d"
import script from "./ShuJuOld.vue?vue&type=script&lang=js"
export * from "./ShuJuOld.vue?vue&type=script&lang=js"
import style0 from "./ShuJuOld.vue?vue&type=style&index=0&id=6396498d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports